<template>
  <div class="day" v-bind:class="{'active': isActive, 'ranged': isRange, 'start': isStart, 'end': isEnd}" @click="selectDay">
    {{ text }} <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['text', 'isActive', 'isRange', 'isStart', 'isEnd', 'isSelected'],
  name: 'Day',
  methods: {
    selectDay () {
      if (!this.isActive) {
        return
      }
      this.$emit('daySelected')
    }
  }
}
</script>

<style>
.day {
  position: relative;
  width: 24px;
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  cursor: default;
  color: #F1F1F1;
  margin-top: 4px;
  transition: .2s;
}

.day.active {
  cursor: pointer;
  color: #344054;
  transition: .2s;
}

.day.active:hover {
  border-radius: 20px;
  background: #F2F4F7;
  color: #344054;
  font-weight: 500;
  transition: .2s;
}

.day.ranged {
  background: var(--beel-secondary);
  color: var(--beel-primary);
  font-weight: 500;
  transition: .2s;
}

.day.start, .day.end {
  border-radius: 20px;
  background: var(--beel-primary);
  color: #FFF;
  transition: .2s;
}

.day.start:hover, .day.end:hover {
  background: var(--beel-primary);
  color: #FFF;
  transition: .2s;
}

.day.ranged:hover {
  background: var(--beel-primary);
  color: #FFF;
  font-weight: 500;
  transition: .2s;
}

.day.ranged:hover:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  border-radius: 0;
  height: 100%;
  background-color: var(--beel-secondary);
  z-index: 1;
  transition: .2s;
}

.day.start.ranged:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  border-radius: 50% 0 0 50%;
  height: 100%;
  background-color: var(--beel-secondary);
  z-index: -1;
}

.day.end.ranged:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 0 50% 50% 0;
  background-color: var(--beel-secondary);
  z-index: -1;
}

.day.start.end:before {
  content: '';
  background-color: unset;
}

@media (max-width: 1360px) {
  .day {
    padding: 9px;
  }
}

@media (max-width: 1305px) {
  .day {
    padding: 8px;
  }
}

@media (max-width: 1250px) {
  .day {
    padding: 7px;
    font-size: 15px;
  }
}

@media (max-width: 1195px) {
  .day {
    padding: 6px;
  }
}

@media (max-width: 1050px) {
  .day {
    padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/CalendarComponent/Day.vue